export default "__VITE_ASSET__Bx6HKXcZ__"